import React, {useState, useEffect} from 'react';
import MovieSearchResults from "../MovieSearchResults/MovieSearchResults";
import './MovieSearch.scss';
import getMovieData from "../utilities/movieApiSearch";
import { H1, H2 } from '../ui-library/Headings'
import MediaResultCard from "../MediaResultCard";
import MediaTypeFilter from "../MediaTypeFilter/MediaTypeFilter";
import { Search, X } from 'lucide-react';


function MovieSearch () {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(null);
  const [searchFilter, setSearchFilter] = useState('movie');
  const [hasResults, setHasResults] = useState(false);
  const [searchActive, setSearchActive] = useState(false);


  const minQueryLength = 3;

  const filterOptions = [
    {
      label: 'Movie',
      value: 'movie'
    },
    {
      label: 'TV Show',
      value: 'tv'
    },
    {
      label: 'Person',
      value: 'person'
    }
  ];


function search(query) {
  if (query.length < minQueryLength) {
    setResults(null);
    setHasResults(false);
    setSearchActive(false);
    return;
  }

  getMovieData(query).then(({ results }) => {
    setResults(results);
    setHasResults(true);
    setSearchActive(true);
  });
}

  function handleChange(e){
  const next = e.target.value;
  setQuery(next);
  search(next);
}

  function handleClearSearch(e){
    e.preventDefault();
    setQuery('');
    document.getElementById('searchFormInput').focus();
  }

  function handleClick(e){
    e.preventDefault();
  }

  function handleRadioChange(e){
    setSearchFilter(e.target.value);
  }

  const resultCards = () => {
    if (results) {
      return results.map((result) =>
          <MediaResultCard key={result.id} result={result} />
      )
    }
  };

 
  return (
      <React.Fragment>
        <h1 className={'home__title' + (searchActive ? ' search-active' : '')}>Cinematheque</h1>
        <form className={'searchForm' + (searchActive ? ' search-active' : '') }>
          <div className={'searchBar'}>
            <div className={'searchInput'}>
             <div className="searchField">
             <input
            id="searchFormInput"
            name="searchInput"
            className="searchFormInput"
            type="text"
            value={query}
            autoComplete="off"
            placeholder={`Search for a ${searchFilter === 'tv' ? 'tv show' : searchFilter}`} 
            aria-label={`Search for a ${searchFilter === 'tv' ? 'tv show' : searchFilter}`}
            onChange={handleChange}
            />
          </div>
              <button
  type="button"
  className="resetInput"
  onClick={handleClearSearch}
  aria-label="Clear search"
>
  <X className="clearIcon" />
</button>
            </div>
            <button type="button" className="button button-search" onClick={handleClick}>
  <Search className="searchIcon" />
  <span className="button-search-text">Search</span>
</button>
          </div>
          <MediaTypeFilter options={filterOptions} onChange={handleRadioChange} currentSelection={searchFilter}/>
        </form>

        {query ?
            <section className={'searchResultsContainer'} id={'resultContainer'}>
              <H2 className={'searchTitle'} content={(hasResults) ? "Results for: " + query : "No results found"} />

              {(hasResults) ? <MovieSearchResults searchquery={query} searchFilter={searchFilter}/> : ''}

            </section> : ''}

      </React.Fragment>
  )
}



export default MovieSearch;